// extracted by mini-css-extract-plugin
export var productItem = "ProductCard-module--productItem--tMY15";
export var imageContainer = "ProductCard-module--imageContainer--JYWyo";
export var productTitle = "ProductCard-module--productTitle--27Gle";